export function zoom() {
    const trigger = document.querySelectorAll('[data-zoom-trigger]');

    for (const el of trigger) {
        const id = el.dataset.zoomTrigger;
        const target = document.querySelector(`[data-zoom-target="${id}"]`);
        el.addEventListener('click', (e) => {
            e.currentTarget.classList.toggle('-zoom');
            target.classList.toggle('-zoom');
        });
    }
}
